export function PlatformOverviewPage() {
  return (
    <div className="flex flex-col gap-8">
      <div>
        <h1 className="font-serif text-2xl tracking-tight text-neutral-900">Overview</h1>
        <p className="mt-1 text-sm text-neutral-600">
          A cross-tenant view of the Witness platform.
        </p>
      </div>
      <div className="rounded border border-dashed border-neutral-300 bg-neutral-50 px-4 py-6 text-sm text-neutral-500">
        Aggregate operational metrics will appear here in a later slice.
      </div>
    </div>
  );
}

export function PlatformSectionPlaceholder({ name }: { name: string }) {
  return (
    <div className="flex flex-col gap-3">
      <h1 className="font-serif text-2xl tracking-tight text-neutral-900">{name}</h1>
      <p className="text-sm text-neutral-600">Not yet implemented — coming in a later slice.</p>
    </div>
  );
}
